import config from "../_config/config";
import { authHeader } from "../_helpers";
import axios from "axios";

axios.defaults.baseURL = config.apiUrl;
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers.post["X-Requested-With"] = "XMLHttpRequest";
axios.defaults.headers.put["Content-Type"] = "application/json";
axios.defaults.headers.put["X-Requested-With"] = "XMLHttpRequest";

export const pssService = {
  getSummary,
  saveSummary,
};

function getSummary(patientHash) {
  var sett = { headers: authHeader() };
  return axios
    .get("pss/" + patientHash + "/summary", sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function saveSummary(patientHash, summaryText) {
  var sett = { headers: authHeader() };
  return axios
    .post("pss/" + patientHash + "/save", { summary_text: summaryText }, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}
